import { FC, memo } from 'react';
import { Stack } from '../UI';
import { LeaderboardProps } from './Leaderboard.types';
import { LeaderboardItem } from './LeaderboardItem/LeaderboardItem';

export const Leaderboard: FC<LeaderboardProps> = memo(({ leaders, currentUserPublicId }) => {
    return (
        <Stack spacing={8}>
            {leaders.map((leader, index) => (
                <LeaderboardItem key={index} leader={leader} isCurrentUser={leader.publicId === currentUserPublicId} />
            ))}
        </Stack>
    );
});
